import { DESO_DOLLAR_PROFILE_NAME } from 'constants/AppConstants.dev';
import { ProfileEntryResponse } from 'deso-protocol';

export const isDesoDollar = (username?: string) => username === DESO_DOLLAR_PROFILE_NAME;
